var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{staticClass:"effective-date",attrs:{"label":""},on:{"mouseenter":function($event){_setup.isHovered = true},"mouseleave":function($event){_setup.isHovered = false},"click":_setup.openPostionEffective}},[_c('span',{staticClass:"effective-res-label"},[_vm._v(" "+_vm._s(_setup.formattedEffectiveDate)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }